import { orderHistoryService, productServiceWithInHouseData, paginatedOrderHistoryService } from 'config/api';
import { getOrderParams } from 'utils';
import actionTypes from './actionTypes';

/**
 * CLient Order History
 */
export const getPaginatedClientOrders = (requestBody, apiVersion = 'v1') => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_CLIENT_ORDER_HISTORY_LOADING,
  });

  try {
    const url = `/${apiVersion}/retrieve/customerOrders`;
    const { data } = await paginatedOrderHistoryService.post(url, requestBody);

    dispatch({
      type: actionTypes.GET_CLIENT_ORDER_HISTORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_CLIENT_ORDER_HISTORY_ERROR,
      payload: error,
    });
  }
};

export const getPaginatedClientOrdersV2 = (requestBody) => getPaginatedClientOrders(requestBody, 'v2');

export const getClientOrders = (id, days) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_CLIENT_ORDER_HISTORY_LOADING,
  });

  try {
    const url = `customers/${id}/orders${getOrderParams(days)}`;
    let { data: orderList } = await orderHistoryService.get(url);

    // in case of orders aren't found for supplied client id there might returned an empty object `{}`
    // So, just validate that array instance and replace it with empty array to not break further logic
    if (!Array.isArray(orderList)) {
      orderList = [];
    }

    dispatch({
      type: actionTypes.GET_CLIENT_ORDER_HISTORY_SUCCESS,
      payload: orderList,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_CLIENT_ORDER_HISTORY_ERROR,
      payload: error,
    });
  }
};

export const setClientOrders = (orders = []) => {
  return {
    type: actionTypes.GET_CLIENT_ORDER_HISTORY_SUCCESS,
    payload: orders,
  };
};

export const setAssociateOrders = (orders = []) => {
  return {
    type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_SUCCESS,
    payload: orders,
  };
};

export const setOrderDetails = (order = {}) => {
  return {
    type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
    payload: order,
  };
};

export const getOrderbyId = (orderId) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ORDER_BY_ID_LOADING,
  });

  try {
    const url = `orders/${orderId}`;
    const response = await orderHistoryService.get(url);

    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_ERROR,
      payload: error,
    });
  }
};

export const getProductsForOrder = () => async (dispatch, getState) => {
  dispatch({
    type: actionTypes.GET_PRODUCTS_FOR_ORDER_LOADING,
  });

  const order = getState().clientsModule?.orderDetails?.data;
  const clientId = order?.accountId;
  const productsIds = order?.orderDetails
    ?.map(({ items = [] }) => items.map((item) => item.pimSkuId || item.cmosSkuId))
    .join(',');
  try {
    const response = await productServiceWithInHouseData.get(`?product_id=${productsIds}`, { clientId });

    dispatch({
      type: actionTypes.GET_PRODUCTS_FOR_ORDER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_PRODUCTS_FOR_ORDER_ERROR,
      payload: error,
    });
  }
};

export const resetClientOrders = () => ({
  type: actionTypes.RESET_CLIENT_ORDER_HISTORY,
});

export const resetClientOrdersKeepFilters = () => ({
  type: actionTypes.RESET_CLIENT_ORDER_HISTORY_KEEP_FILTERS,
});

export const restoreClientOrders = (ordersState) => ({
  type: actionTypes.RESTORE_CLIENT_ORDER_HISTORY,
  payload: ordersState,
});

export const restoreAssociateOrders = (ordersState) => ({
  type: actionTypes.RESTORE_ASSOCIATE_ORDER_HISTORY,
  payload: ordersState,
});

/**
 * Resend Receipt
 */
export const resendReceipt = (receiptEmail, orderId) => async (dispatch) => {
  dispatch({
    type: actionTypes.RESEND_RECEIPT_LOADING,
  });

  try {
    const { data: payload } = await new Promise((resolve) => {
      setTimeout(() => resolve({ data: { receiptEmail, orderId } }), 2000);
    });
    dispatch({ type: actionTypes.RESEND_RECEIPT_SUCCESS, payload });
  } catch (error) {
    dispatch({
      type: actionTypes.RESEND_RECEIPT_ERROR,
      payload: error,
    });
  }
};

/**
 * Associate Order History
 */
export const getPaginatedAssociateOrders = (requestBody, version = 'v1') => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_LOADING,
  });

  try {
    const url = `${version}/retrieve/associateOrders`;
    const { data } = await paginatedOrderHistoryService.post(url, requestBody);
    dispatch({
      type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_ERROR,
      payload: error,
    });
  }
};

export const getPaginatedAssociateOrdersV2 = (requestBody) => getPaginatedAssociateOrders(requestBody, 'v2');

export const resetAssociateOrders = () => ({
  type: actionTypes.RESET_ASSOCIATE_ORDER_HISTORY,
});

export const resetAssociateOrdersKeepFilters = () => ({
  type: actionTypes.RESET_ASSOCIATE_ORDER_HISTORY_KEEP_FILTERS,
});

export const resetOrderDetails = () => ({
  type: actionTypes.RESET_ORDER_DETAILS,
});

export const getOrderDetailsNew = (orderId, channelCode, version = 'v1') => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ORDER_BY_ID_LOADING,
  });

  try {
    const url = `/${version}/fetchOrderDetails/order/${orderId}/channel/${channelCode}`;
    const { data } = await paginatedOrderHistoryService.get(url);

    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
      payload: { ...data, channel: channelCode },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_ERROR,
      payload: error,
    });
  }
};

export const getOrderDetailsV2 = (orderId, channelCode) => getOrderDetailsNew(orderId, channelCode, 'v2');
